import React, {Fragment } from "react";
import "../../ui-styles/cards/colorCards.css";

import UpcomingAppointments from "./dashboard/UpcomingAppointments";
import PendingAppointments from "./dashboard/PendingAppointments";
import CancelledAppointments from "./dashboard/CancelledAppointments";
import NewRegisteredPatients from "./dashboard/NewRegisteredPatients";
import TotalRegisteredPatients from "./dashboard/TotalRegisteredPatients";
// import SuccessfulVideoCalls from "./dashboard/SuccessfulVideoCalls";
import TotalClinics from "../admin/dashboard/components/TotalClinicCard";
import TotalDoctors from "../admin/dashboard/components/TotalDoctorsCard";

const CardsList = (props) => {
    const { usersCount, apptCount, role } = props;

    return (
        <div className="clrCrdCntanr">
            <div className="clrcrdsWapr">
                {role === "CA" && (
                    <Fragment>
                        <TotalClinics clinics={usersCount?.clinic ? usersCount.clinic : 0} />
                        <TotalDoctors doctors={usersCount?.doctor ? usersCount.doctor : 0} />
                    </Fragment>
                )}
                {role === "C" && (
                    <Fragment>
                        <TotalDoctors doctors={usersCount?.totalDoctorCount ? usersCount.totalDoctorCount : 0} />
                    </Fragment>
                )}
                <TotalRegisteredPatients patients={usersCount?.totalpatient ? usersCount.totalpatient : 0} />
                <NewRegisteredPatients patients={usersCount?.todaypatient ? usersCount.todaypatient : 0} />

                <PendingAppointments totalPending={apptCount?.todaypendingappointment ? apptCount.todaypendingappointment : 0} />
                <CancelledAppointments totalCancelled={apptCount?.todaycancelledappointments ? apptCount.todaycancelledappointments : 0} />
                <UpcomingAppointments totalUpcoming={apptCount?.upcomingappointments ? apptCount.upcomingappointments : 0} />

                {/* <SuccessfulVideoCalls />*/}
            </div>
        </div>
    );
};
export default CardsList;
